module.exports = __webpack_public_path__ + "img/iPhones.5355fe38.png";